export const checkIfPhoneIsValid = value => {
  const mobileRegex = /^01[0-9]{9}$/i;
  if (!mobileRegex.test(value)) {
    return false;
  }
  return true;
};

export const checkIfEmailIsValid = value => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;
  if (!emailRegex.test(value)) {
    return false;
  }
  return true;
};
